module.exports = __webpack_public_path__ + "static/media/meditate6.81cd42a0.jpg";